var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.debug === 'true' || _vm.debug === true)?_c('span',[_vm._v(_vm._s(_vm.version))]):_vm._e(),_c('div',{staticClass:"mt-4"},[_c('historial',{attrs:{"ordinario":false}}),_c('nuevo',{attrs:{"ordinario":false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }